import { useEffect } from "react";

export default function Newsletter() {
  useEffect(() => {
    // Vérifier si le script n'existe pas déjà pour éviter les doublons
    if (!document.querySelector("script[data-form='4a9eab84-9613-11f0-86e6-9d40842e837e']")) {
      const script = document.createElement("script");
      script.src = "https://eomail5.com/form/4a9eab84-9613-11f0-86e6-9d40842e837e.js";
      script.async = true;
      script.dataset.form = "4a9eab84-9613-11f0-86e6-9d40842e837e";
      document.getElementById("newsletter-form-container").appendChild(script);
    }
  }, []);

  return (
    <div className="flex flex-col lg:gap-[30px] items-center justify-center lg:mt-[100px] mt-[50px]">
      {/* Le script EmailOctopus va injecter le formulaire ici */}
      <div id="newsletter-form-container"></div>
    </div>
  );
}
